import { FC } from 'react';
import { BoxV2 as Box } from 'portal-commons';

const Divider: FC = () => (
  <Box sx={{ height: '1px', width: '100%', bg: '#C0CCD4' }} />
);

export default Divider;
